import { Component, OnInit, Input, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { IFieldColumnOptions } from '../../models';
import { DataGridComponent } from '../data-grid/data-grid.component';
import { Observable } from 'rxjs';
import { IDynamicComponent } from '../../../dynamic-component/IDynamicComponent';

@Component({
  selector: 'ps-data-grid-field-editor-column',
  templateUrl: './data-grid-field-editor-column.component.html',
  styleUrls: ['./data-grid-field-editor-column.component.css']
})
export class DataGridFieldEditorColumnComponent implements OnInit {

  @Input() model: any;
  @Input() column: IFieldColumnOptions;
  @Input() grid: DataGridComponent;

  dynamicComponent: IDynamicComponent;

  constructor() { 
    
  }

  ngOnInit() {
    if (this.column.editComponent) 
      this.dynamicComponent = this.column.editComponent(this.model, this.column);
  }
  
  get value() {
    return this.model[this.column.field];
  }

  set value(val) {
    this.model[this.column.field] = val;
  }
}
